<template>
  <div>
    <div class="page-title-container lighter-shadow">
      <i class="fas fa-car-side icon"></i>
      <h1>Автопарк</h1>
      <LiteButton class="add-button"
                  v-if="isUserAdmin"
                  @click.native="addCarClicked"
                  :hoverColor="'green'"
                  :icon="'far fa-plus-square'"
                  :text="'Добавяне на автомобил'">
      </LiteButton>
    </div>
    <Grid class="grid"
          :config="config"
          :gridData="gridData"
          :loading="isLoading"
          @row-clicked="rowClicked">
    </Grid>
  </div>
</template>

<script>
import Grid from "@/shared/components/grid/Grid";
import carListGridConfig from "@/components/car/car-list-grid.config";
import redirectService from "@/services/redirect.service";
import LiteButton from "@/shared/components/button/LiteButton";
import carService from "@/services/car.service";
import {mapGetters} from "vuex";

export default {
  name: "CarList",
  components: {LiteButton, Grid},
  created() {
    this.$store.dispatch('fetchCarEnums');

    carService.fetchCars()
        .then(({data}) => {
          if (data) {
            this.gridData = data.map((item) => {
              const tempItem = item;
              tempItem.statusName = item.status ? item.status.name : '';
              tempItem.typeName = item.type ? item.type.name : '';
              tempItem.categoryName = item.category ? item.category.name : '';
              return tempItem;
            });
            this.isLoading = false;
          }
        });
  },
  data() {
    return {
      config: carListGridConfig,
      gridData: [],
      isLoading: true
    }
  },
  methods: {
    addCarClicked() {
      redirectService.redirectToAddCar();
    },
    rowClicked(row) {
      redirectService.redirectToCarInfo(row.id);
    }
  },
  computed: {
    ...mapGetters(['isUserAdmin'])
  }
}
</script>

<style scoped>
.add-button {
  width: 350px;
  float: right;
  margin: 35px 0;
  font-size: 25px;
  color: var(--primary-blue);
}

.grid {
  margin-top: 30px;
  display: inline-block;
}
</style>
